/**
 * Created by Ivan on 20.03.2025
 */

ExclamationView.prototype.showMessage = function (message, type) {
    const styles = cleverapps.styles.Exclamations;
    let effect = message === "message.YouWin" ? "game.exclamations.sound_win" : "game.exclamations.keep_going";

    const font = cleverapps.styles.FONTS.CONGRATS_MESSAGE_FONT;
    const fontColor = styles[message];
    if (fontColor) {
        font.color = fontColor.color;
    } else if (type === Exclamation.Types.Warning) {
        font.color = styles["warning"].color;
    } else {
        font.color = styles["default"].color;
    }

    let animation = "lets_go";
    if (cleverapps.exclamation.getCongratulations().indexOf(message) !== -1) {
        effect = `game.exclamations.${message}`;
        animation = message;
        message = `message.${message}`;
    } else if (message === "message.KeepGoing") {
        effect = "game.exclamations.go_on";
    } else if (message === "message.Shuffle") {
        animation = "shuffle";
        effect = "game.exclamations.shuffle";
    }

    this.createAnimation(animation);
    this.createMsg(message, font);
    this.playEffect(effect);
};

ExclamationView.prototype.createText = function (message, font) {
    const msg = Messages.get(message);
    // eslint-disable-next-line no-restricted-syntax
    const text = cleverapps.UI.generateTTFText(msg, font);
    if (msg.indexOf(" ") !== -1) {
        text.setDimensions(this.width, 0);
    } else {
        text.fitTo(this.width);
    }
    text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
    text.setAlignment(this.width / 2, this.height / 2);
    this.addChild(text);

    return text;
};

ExclamationView.prototype.createMsg = function (message, font) {
    const text = this.createText(message, font);
    text.setRotation(10);

    const textScale = 1;
    text.setScale(0.1);
    text.setVisible(false);

    text.runAction(new cc.Sequence(
        new cc.DelayTime(0.2),
        new cc.Show(),
        new cc.ScaleTo(0.3, textScale).easing(cc.easeInOut(3)),
        new cc.DelayTime(0.55),
        new cc.ScaleTo(0.3, 0.1 * textScale),
        new cc.RemoveSelf()
    ));
};

ExclamationView.prototype.playEffect = function (effect) {
    const styles = cleverapps.styles.Exclamations;

    const delay = styles.sound ? styles.sound.delay : 0;
    this.runAction(new cc.Sequence(
        new cc.DelayTime(delay),
        new cc.CallFunc(() => {
            cleverapps.effects.fire(effect);
        })
    ));
};

cleverapps.styles.Exclamations = cleverapps.overrideStyles(cleverapps.styles.Exclamations, {
    width: 760,
    scale: [0.8, 1, 1],
    sound: { delay: 0.6 },

    "default": {
        color: cleverapps.styles.COLORS.CONGRATS_BLUE
    },
    "warning": {
        color: cleverapps.styles.COLORS.CONGRATS_DARK_RED
    },
    "yeah": {
        color: cleverapps.styles.COLORS.CONGRATS_RED
    },
    "super": {
        color: cleverapps.styles.COLORS.CONGRATS_LIGHT_GREEN
    },
    "yay": {
        color: cleverapps.styles.COLORS.CONGRATS_BLUE
    },
    "lets_go": {
        color: cleverapps.styles.COLORS.CONGRATS_ORANGE
    },
    "ohyeah": {
        color: cleverapps.styles.COLORS.CONGRATS_PURPLE
    },
    "oh": {
        color: cleverapps.styles.COLORS.CONGRATS_GREEN
    },
    "wow": {
        color: cleverapps.styles.COLORS.CONGRATS_DARK_RED
    }
}, true);